<template>
  <div
    @click="goToCourse"
    class="d-flex justify-content-center"
    :class="index == 8 ? 'pr-5 mr-5' : ''"
  >
    <img
      class="rank-image"
      :src="respectiveNumberIconPath"
      :alt="course.name"
      height="258.13"
      :width="widthElement"
    />
    <!-- <div
      class="course-shape ml-n1"
      :style="{ background: 'url(' + course.vertical_cover + '), #333', backgroundSize: 'cover', backgroundPosition: 'center' }"
    /> -->
    <div
      class="course-shape position-relative"
      :class="{ 'ms-n4': index < 9, 'ms-n6': index >= 9 }"
    >
      <course-item
        :item="course"
        :shape="'vertical'"
        :show-infos="false"
        :show-progress="false"
        :is-conference="false"
        :is-lesson="false"
        :isHome="false"
        isRanked
      />
    </div>
  </div>
</template>

<script>
import { NUMBERS_ICONS_PATH } from "@/constants.js";
import CourseItem from "@/components/thumbnails/CourseItem";
export default {
  components: {
    CourseItem,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    respectiveNumberIconPath() {
      return NUMBERS_ICONS_PATH[this.index];
    },
    widthElement() {
      return this.course.index > 8 ? "250" : "199.55";
    },
    currentSignature() {
      return this.$user.user && this.$user.user.signature
        ? this.$user.user.signature
        : 1;
    },
    isLocked() {
      return (
        this.currentSignature &&
        this.course.signatures &&
        !this.course.signatures.includes(this.currentSignature)
      );
    },
  },
  methods: {
    goToCourse() {
      // if (isLocked) {
      //   return
      // }

      this.$router.push({
        name: "course-about",
        params: { id: this.course.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ms-n6 {
  margin-left: -90px;
}
.rank-image,
.course-shape {
  height: 170px;
  width: auto;

  @media (min-width: 992px) {
    height: 258.13px;
  }
}

.course-shape {
  aspect-ratio: 175/258.12;
  border-radius: 5px;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.ml-n1 {
  margin-left: -1.3rem;

  @media (min-width: 992px) {
    margin-left: -2rem;
  }
}
</style>
